// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fxsK","colBig":"styles_colBig__2tXy4","colSmall":"styles_colSmall__3jykC"};